import React, { useEffect } from 'react'

export default function FlashAlert({text, type, constant, html, centred, onHide}) {
  useEffect(() => {
    var hideFlash = function() {
      onHide()
    }

    if (!constant) setTimeout(hideFlash, 3000)
  }, [])

  const alertClass = () => {
    switch (type)
    {
      case 'error':
        return ' alert-warning'
      case 'success':
        return ' alert-success'
      case 'notice':
        return ' alert-info'
      case 'alert':
        return ' alert-danger'
      default: 
        return ` ${type}`
    }
  }

  const alignClass = () => {
    return centred ? ' text-center' : ''
  }

  return <div id='flash_messages'>
    <div className={'flash-message alert fade in' + alertClass() + alignClass()}>
      <button className='close' onClick={onHide}>
        <i className= 'fa fa-times'></i>
      </button>
      { html && <div className='content' dangerouslySetInnerHTML={{__html: text}}></div> }
      { !html && text }
    </div>
  </div>
}
